import { isDesiredPrediction, neighborhoods as placeUtilNeighborhoods } from './placesUtils.js';
import Bloodhound from './external-adapters/typeaheadJqueryAdapter';

/* global google */

export const locationBloodhound = {};
locationBloodhound.make = function () {
    var searchOptions = {
        types: ['(regions)'],
        componentRestrictions: { country: 'us' },
    };

    var locationHound = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 5,
        dupDetector: function (remote, local) {
            return remote.place_id === local.place_id;
        },
        local: [],
    });

    // Hack the "search" method to contact Google's Places API
    locationHound.search = function (query, sync) {
        searchOptions.input = query;
        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions(searchOptions, function (predictions) {
            const lowerQuery = query.toLowerCase();
            const neighborhoods = placeUtilNeighborhoods.filter(
                place => place.name.toLowerCase().startsWith(lowerQuery),
            );

            var locations = [];
            if (predictions) {
                locations = predictions
                    .filter(isDesiredPrediction)
                    .map(function (prediction) {
                        return {
                            name: prediction.description.replace(/, (United States|USA)/, ''),
                            place_id: prediction.place_id,
                        };
                    });
            }
            sync(neighborhoods.concat(locations), false);
        });
    };

    return locationHound;
};
